// actions
export const NEXT_LESSON = 'NEXT_LESSON'
export const PREV_LESSON = 'PREV_LESSON'

// commit
export const SET_LESSON_STEP_PROGRESS = 'SET_LESSON_STEP_PROGRESS'
export const SET_THEMES = 'SET_THEMES'
export const SET_LESSONS = 'SET_LESSONS'
export const SET_LESSON_STEPS = 'SET_LESSON_STEPS'
export const SET_FIREBASE_ID = 'SET_LESSON_FIREBASE_ID'
export const RESET_FIREBASE_ID = 'RESET_LESSON_FIREBASE_ID'
export const SET_THEME_FUNNELS = 'SET_THEME_FUNNELS'
